import { useEffect } from 'react';

const DEFAULT_TITLE = 'ProCam360 | Tu opción en cabinas 360';

/**
 * Hook para gestionar el título de la página de forma centralizada.
 * Al desmontar el componente, restaura el título por defecto.
 *
 * @param {string} title - Título específico de la página
 */
function usePageTitle(title) {
  useEffect(() => {
    document.title = title
      ? `${title} — ProCam360`
      : DEFAULT_TITLE;

    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);
}

export default usePageTitle;
